import { useAppSelector } from 'src/store/hooks'
import { isOrganisationProfile } from 'src/api/profile'

/**
 * Custom hook to check if the current user is an organization
 * @returns boolean indicating if the current user is an organization account
 */
export const useIsOrganisation = (): boolean => {
  const currentUser = useAppSelector((state) => state.account.currentUser)

  if (!currentUser) {
    return false
  }

  return isOrganisationProfile(currentUser)
}
